import { render, staticRenderFns } from "./AssessmentScoresDetails.vue?vue&type=template&id=8d41f450&"
import script from "./AssessmentScoresDetails.vue?vue&type=script&lang=js&"
export * from "./AssessmentScoresDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d41f450')) {
      api.createRecord('8d41f450', component.options)
    } else {
      api.reload('8d41f450', component.options)
    }
    module.hot.accept("./AssessmentScoresDetails.vue?vue&type=template&id=8d41f450&", function () {
      api.rerender('8d41f450', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/AssessmentScoresDetails.vue"
export default component.exports